export namespace DateTimeUtil {
  export function toLocaleDateTimeString(locale: string, date?: Date): string {
    if (!date) return '';

    return `${date.toLocaleDateString(locale)} - ${date.toLocaleTimeString(locale)}`;
  }

  export function toPureDate(value?: string): string | undefined {
    if (!value) return value;

    const PURE_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
    // Already in new format
    if (PURE_DATE_REGEX.test(value)) return value;

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;

    const normalized = new Date(Date.UTC(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate()));

    // Legacy values were saved as moments of a picked date. Convert back to pure date.
    // Example: 22:00Z -> next day, 02:00Z -> previous day.
    const utcHours = parsed.getUTCHours();
    if (utcHours > 12) {
      normalized.setUTCDate(normalized.getUTCDate() + 1);
    } else {
      normalized.setUTCDate(normalized.getUTCDate() - 1);
    }

    return normalized.toISOString().slice(0, 10);
  }
}
